<template>
  <list-select
      ref="select"
      async
      :input-size="1"
      :emit-only-value="false"
      v-on:input="(v) => $emit('input', v)"
      :search-data="search"
      :parse-callback="parse"
      v-model="model"
  />
</template>

<script>
import ListSelect from "@/reuse/input/ListSelect"
import {listTopics} from "@/domain/form/services/topic"
export default {
  name: "FormTopicSelect",
  props: {
    value: {
      required: true
    },
    form: {
      required: false
    }
  },
  data () {
    return {
      model: this.value,
      result: []
    }
  },
  watch: {
    value (v) {
      this.$nextTick(() => {
        if (v !== this.model) {
          this.$refs.select.autoSelectValue(v)
        }
      })
    }
  },
  components: {ListSelect},
  methods: {
    search (terms) {
      console.log('Find', this.model)
      const filtros = []
      if (terms) {
        filtros.push('search=' + terms)
      }
      if (this.form) {
        filtros.push('form=' + this.form.id)
      }
      return new Promise((resolve, reject) => {
        listTopics(100, 1, '&sortBy=order&' + filtros.join('&'))
            .then(response => {
              this.result = response.data.result
              let list = response.data.result.map((obj) => {
                return {
                  ...obj,
                  value: obj.id,
                  label: obj.name
                }
              })/*.sort((a, b) => {
                if (a.name > b.name) {
                  return 1;
                }
                if (a.name < b.name) {
                  return -1;
                }
                // a must be equal to b
                return 0;
              })*/
              resolve(list)
            })
            .catch(({response}) => {
              reject(response)
            })
      })
    },
    parse (v) {
      if (v && v.name) {
        return v.name
      }
      return v
    }
  }
}
</script>
